import React from "react";

const StickyMenu = () => {
  return (
    <div 
      style={{
        position: 'fixed',
        left: '0',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1000,
        backgroundColor: '#2c3e50',
        borderRadius: '0 12px 12px 0',
        boxShadow: '3px 0 15px rgba(0,0,0,0.3), 0 0 20px rgba(231, 76, 60, 0.3)',
        padding: '0',
        transition: 'all 0.3s ease',
        animation: 'pulse 2s infinite'
      }}
    >
      {/* YENİ Badge */}
      <div
        style={{
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          backgroundColor: '#e74c3c',
          color: 'white',
          fontSize: '10px',
          fontWeight: '700',
          padding: '4px 8px',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(231, 76, 60, 0.4)',
          animation: 'bounce 1.5s infinite',
          zIndex: 1001
        }}
      >
        YENİ
      </div>

      <a 
        href="https://bul.muzisyen.app" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px 12px',
          color: 'white',
          textDecoration: 'none',
          fontSize: '12px',
          fontWeight: '700',
          letterSpacing: '1px',
          writingMode: 'vertical-rl',
          textOrientation: 'mixed',
          transition: 'all 0.3s ease',
          minHeight: '120px',
          width: '45px',
          position: 'relative'
        }}
        onMouseEnter={(e) => {
          e.target.parentElement.style.backgroundColor = '#34495e';
          e.target.parentElement.style.transform = 'translateY(-50%) translateX(8px) scale(1.05)';
          e.target.parentElement.style.boxShadow = '5px 0 25px rgba(0,0,0,0.4), 0 0 30px rgba(231, 76, 60, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.target.parentElement.style.backgroundColor = '#2c3e50';
          e.target.parentElement.style.transform = 'translateY(-50%) translateX(0) scale(1)';
          e.target.parentElement.style.boxShadow = '3px 0 15px rgba(0,0,0,0.3), 0 0 20px rgba(231, 76, 60, 0.3)';
        }}
      >
        <i 
          className="fa fa-music" 
          style={{ 
            fontSize: '18px',
            marginBottom: '10px',
            display: 'block',
            animation: 'musicNote 3s ease-in-out infinite'
          }}
        ></i>
        <span style={{ 
          writingMode: 'vertical-rl',
          textOrientation: 'mixed',
          lineHeight: '1.2'
        }}>
          MÜZİSYEN BUL
        </span>
      </a>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes pulse {
          0% { box-shadow: 3px 0 15px rgba(0,0,0,0.3), 0 0 20px rgba(231, 76, 60, 0.3); }
          50% { box-shadow: 3px 0 15px rgba(0,0,0,0.3), 0 0 25px rgba(231, 76, 60, 0.6); }
          100% { box-shadow: 3px 0 15px rgba(0,0,0,0.3), 0 0 20px rgba(231, 76, 60, 0.3); }
        }
        
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-4px); }
          60% { transform: translateY(-2px); }
        }
        
        @keyframes musicNote {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
      `}</style>
    </div>
  );
};

export default StickyMenu; 